(function() {
	'use strict';

	angular.module('monthlyFlightTime').config(config);

	function config($stateProvider) {
		$stateProvider
				.state(
						'monthlyFlightTime',
						{
							url : '/monthly-flight-time',
							views : {
								'monthlyFlightTimeView' : {
									templateUrl : 'monthly-flight-time/views/monthly-flight-time.tpl.html',
									controller : 'MonthlyFlightTimeCtrl',
									controllerAs : 'monthlyFlightTime'
								}
							}
						});
	}
}());
